// Shared by the row and the page's column header so the two can never drift apart. Columns, gap, and
// the left/right inline padding together determine cell alignment — changing any one of them on only
// one side would silently misalign the header labels against the row cells beneath them.
export const FEATURE_FLAG_GRID_COLUMNS = 'minmax(320px, 1fr) 170px 110px 100px 230px 28px';
export const FEATURE_FLAG_LIST_MIN_WIDTH = '1160px';
export const FEATURE_FLAG_GRID_GAP = '16px';
export const FEATURE_FLAG_GRID_PADDING_LEFT = '22px';
export const FEATURE_FLAG_GRID_PADDING_RIGHT = '18px';
